import { FC } from 'react';
import { ProButton } from '../antd';
import { ICON_COLLECTION } from '../constants/icon';
import { BaseOperationButtonProps } from './interface';

/** 取消按钮 */
const CancelButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

CancelButton.defaultProps = {
  icon: ICON_COLLECTION.CANCEL,
  text: '取消',
};

export default CancelButton;
